{
  "login.title": "Se connecter",
  "login.email.label": "Adresse e-mail",
  "login.email.placeholder": "vous@exemple.com",
  "login.submit": "Continuer",
  "login.submitting": "Envoi…",
  "login.passkey": "Utiliser une passkey",
  "login.or": "ou",
  "login.turnstile.failed": "La vérification anti-bot a échoué. Veuillez réessayer.",
  "login.email.invalid": "Adresse e-mail invalide.",
  "login.success": "Un lien de connexion vous a été envoyé.",
  "logout.success": "Vous êtes déconnecté.",
  "session.expired": "Votre session a expiré. Veuillez vous reconnecter.",
  "security.title": "Sécurité",
  "security.passkeys.title": "Passkeys",
  "security.passkeys.intro": "Connectez-vous avec Face ID, Touch ID ou une clé de sécurité, sans attendre de lien.",
  "security.passkeys.empty": "Aucune passkey enregistrée.",
  "security.passkeys.add": "Ajouter une passkey",
  "security.passkeys.adding": "Ajout…",
  "security.passkeys.namePlaceholder": "Nom (optionnel), ex. MacBook",
  "security.passkeys.unnamed": "Passkey sans nom",
  "security.passkeys.created": "Ajoutée le {{date}}",
  "security.passkeys.synced": "Synchronisée",
  "security.passkeys.deviceOnly": "Cet appareil uniquement",
  "security.passkeys.rename": "Renommer",
  "security.passkeys.save": "Enregistrer",
  "security.passkeys.cancel": "Annuler",
  "security.passkeys.delete": "Supprimer",
  "security.passkeys.deleteConfirm": "Supprimer cette passkey ? Vous ne pourrez plus l'utiliser pour vous connecter.",
  "security.passkeys.added": "Passkey ajoutée.",
  "security.passkeys.cancelled": "Ajout annulé.",
  "security.passkeys.alreadyRegistered": "Cet appareil a déjà une passkey pour ce compte.",
  "security.passkeys.loadError": "Impossible de charger vos passkeys.",
  "security.passkeys.retry": "Réessayer",
  "security.passkeys.error": "L'opération a échoué. Réessayez.",
  "security.passkeys.sessionNotFresh": "Pour ajouter une passkey, reconnectez-vous d'abord (session de plus de 24 h).",
  "security.passkeys.signOut": "Se déconnecter",
  "security.passkeys.loading": "Chargement de vos passkeys…",
  "security.unsupported": "Ce navigateur ne prend pas en charge les passkeys.",
  "nudge.passkey.text": "Ajoutez une passkey pour ne plus attendre de lien.",
  "nudge.passkey.add": "Ajouter une passkey",
  "nudge.passkey.later": "Plus tard",
  "login.passkey.cancelled": "Connexion par passkey annulée.",
  "login.passkey.notFound": "Aucune passkey reconnue pour ce site — utilisez le lien par e-mail.",
  "login.passkey.failed": "La connexion par passkey a échoué — utilisez le lien par e-mail."
}
